import { useParams, Link } from "react-router-dom";

const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Our commitment", "Because you may upload personal and children's photographs, we treat your privacy with the utmost seriousness. Your uploads are stored in secure private storage and are only ever used to create your purchased product."],
      ["What we collect", "We collect your name, email, order details, personalization answers and the photos you choose to upload. We never sell your data."],
      ["Photo access", "Only you (as the authenticated customer) and authorized administrators can access your order photos. Uploaded images are never publicly exposed."],
      ["Marketing consent", "We only use your finished product or submitted images for marketing if you explicitly opt in. This is never preselected."],
      ["Analytics", "We use Google Analytics 4 to understand website traffic and performance (such as which pages are visited and how visitors find us). This helps us improve the storefront. We do not send Google Analytics any personally identifiable information — no names, email addresses, phone numbers, home addresses, uploaded photos, or the content of your personalized products. Analytics data is limited to anonymous, aggregated usage and standard traffic-source information. You can opt out using browser privacy settings or a Google Analytics opt-out tool."],
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      ["Agreement", "By using Made For Me Studio you agree to these terms. Our products are personalized digital goods delivered as downloadable files."],
      ["Your responsibilities", "You confirm you have the right to use any photos you upload and that they comply with our content guidelines."],
      ["Delivery", "Digital products are delivered to your account. Estimated timeframes are shown on each product page."],
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      ["Personalized digital products", "Because our products are personalized and digital, refund rules may differ once production has started. Before we begin design, you may request a full refund."],
      ["After production begins", "Once your order enters 'In Design', it is custom-made for you and generally non-refundable. If something isn't right, contact us — we'll make it right with revisions."],
      ["Instant downloads", "Instant-download products are non-refundable once downloaded, as they are delivered immediately."],
    ],
  },
  digital: {
    title: "Digital Product Policy",
    body: [
      ["Format", "All products are delivered as high-resolution printable PDF files sized for US Letter and A4."],
      ["Licensing", "Completed products are licensed for personal, non-commercial use unless otherwise agreed in writing."],
      ["Printing", "You may print your PDF at home or at any print shop for personal use."],
    ],
  },
  photos: {
    title: "Photo Upload & Retention Policy",
    body: [
      ["Secure storage", "Uploaded photos are kept in secure private storage and are only accessible to you and authorized administrators."],
      ["Automatic deletion", "We automatically delete uploaded photos after your order completes. The default retention period is 30 days; administrators may configure 30, 60 or 90 days."],
      ["Your control", "You may request deletion of your photos at any time by contacting our studio."],
    ],
  },
  copyright: {
    title: "Copyright Policy",
    body: [
      ["Your content", "You retain rights to the photos you upload. By uploading, you grant us a limited license to use them solely to create your product."],
      ["Our illustrations", "Illustrations and layouts we create remain the intellectual property of Made For Me Studio and are licensed to you for personal use."],
      ["Reporting", "If you believe content infringes your rights, contact our studio and we will respond promptly."],
    ],
  },
};

export default function Policy() {
  const { type } = useParams();
  const p = POLICIES[type];
  if (!p) return <div className="max-w-3xl mx-auto px-4 py-20 text-center"><p className="text-slate-500">Policy not found.</p><Link to="/" className="text-amber font-semibold">Go home</Link></div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-display text-4xl font-extrabold text-slateink">{p.title}</h1>
      <p className="text-slate-400 text-sm mt-2">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
      <div className="mt-8 space-y-8">
        {p.body.map(([h, b], i) => (
          <div key={i}>
            <h2 className="font-display text-xl font-bold text-slateink">{h}</h2>
            <p className="text-slate-600 mt-2 leading-relaxed">{b}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
